export default function EconomicImpact() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#E8F5E9] mb-6">
            <i className="ri-money-dollar-circle-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">地域経済への貢献</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            地域経済を<br />
            活性化させる
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            新しい産業の創出により、地域経済に年間5億円以上の経済効果を生み出します。<br />
            雇用創出だけでなく、関連産業への波及効果も期待できます。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-hand-coin-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2332] mb-3">直接的効果</h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              雇用創出による給与支払いや、地域企業との取引により、直接的な経済効果を生み出します。
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">年間給与総額 3億円以上</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">地域企業との取引拡大</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">税収増加への貢献</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-store-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2332] mb-3">間接的効果</h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              従業員の消費活動や関連産業の活性化により、地域全体に経済効果が波及します。
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">小売店の売上増加</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">飲食店の活性化</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">サービス業の需要増</span>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#F5F9F6] to-white p-8 rounded-xl border border-[#E8F5E9]">
            <div className="w-14 h-14 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-links-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-[#1A2332] mb-3">産業連携</h3>
            <p className="text-gray-600 mb-4 leading-relaxed">
              地域の既存産業との連携により、新しいビジネスチャンスを創出します。
            </p>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">飼料・資材の地域調達</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">物流・運送業との連携</span>
              </div>
              <div className="flex items-center">
                <i className="ri-checkbox-circle-fill text-[#2D7A3E] mr-2"></i>
                <span className="text-sm text-gray-600">観光産業との協働</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}